import { useAtomValue } from 'jotai';
import { BetTypeContentProps } from '../bet-type-content';
import { oddsPageAtom } from '@/atoms/odds-page';
import { getHomeTeamName, getTeamName, orderMarkets } from '@/utils/odds-utils';
import { useTranslations } from 'next-intl';
import { useAccountInfo } from '@/hooks/query/account';
import { OddsButton } from '@/components/widgets/odds-button';
import { useGetBetTypeSetting, useGetChoiceTitle, useGetGoal } from '@/hooks';

export const BetTypeRowTitleCol3 = ({ matchModel: match, betTypeArray, childMatchTeamNameMap }: BetTypeContentProps) => {
	const getBetTypeSetting = useGetBetTypeSetting();
	const { user } = useAccountInfo();
	const t = useTranslations('General');
	const market = betTypeArray[0];
	const betTypeId = market.BetTypeId;
	const getChoiceTitle = useGetChoiceTitle(betTypeId);
	const oddsData = useAtomValue(oddsPageAtom);
	const { TeamId1, TeamId2, Neu } = match ?? {};
	const getGoal = useGetGoal();
	const homeTeamName = getHomeTeamName(TeamId1 ?? 0, Neu ?? false, t('Neutral_Team'), oddsData?.teamNameMap);
	const awayTeamName = getTeamName(TeamId2 ?? 0, oddsData?.teamNameMap);
	const { betChoices } = getBetTypeSetting(betTypeId, match.GameID);
	const sortedMarkets = orderMarkets(betTypeArray);
	const groupRows = Math.ceil(sortedMarkets.length / 3);
	return (
		<div className="bettype__content bettype__content--group-row-mars">
			{
				[...Array(groupRows).keys()].map((index) => {
					const startIndex = index * 3;
					return (
						<div className="bettype__group" key={sortedMarkets[startIndex].MarketId}>
							<div className="bettype__item">
								{
									betChoices.map(choice => (
										<div className="bettype__title bettype__title--left" key={choice.betTeam}>
											{getChoiceTitle({
												choice,
												market,
												match,
												teamMap: childMatchTeamNameMap ?? oddsData?.teamNameMap
											})}
										</div>
									))
								}
							</div>
							{
								sortedMarkets.slice(startIndex, (startIndex + 3)).map(market => {
									return (
										<div className="bettype__item" key={market.MarketId}>
											{
												betChoices.map((betChoice) => {
													return (
														<OddsButton 
															key={`${market.MatchId}_${market.MarketId}_${market.BetTypeId}_${betChoice.betTeam}`}
															goal={getGoal(market, betChoice)}
															match={match}
															market={market}
															selection={market.Selections[betChoice.betTeam]}
															homeTeamName={homeTeamName}
															awayTeamName={awayTeamName}
															variant={'vertical'}
															betTeam={market.Selections[betChoice.betTeam].SelId} 
															originalPrice={market.Selections[betChoice.betTeam].Price}
															sport={match.GameID}
															type="OU"
															oddsType={user?.OType}
															accountStatus={user?.ActStatus ?? 0}
														/>
													)
												})
											}
										</div>
									)	
								})
							}
						</div>
					)	
				})
			}
		</div>
	);
};